import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useLanguage() {
  const route = useRoute();
  const supportedLanguages = ['en', 'nl', 'es'];
  const defaultLanguage = 'en';

  const lang = computed(() => {
    const paramLang = route.params.lang;
    if (typeof paramLang === 'string' && supportedLanguages.includes(paramLang)) {
      return paramLang;
    }
    return defaultLanguage;
  });

  return {
    lang,
    supportedLanguages,
    defaultLanguage,
  };
}
